export default {
  chatWidget: {
    chatWithUs: 'Chatte mit uns',
    welcomeTitle: 'Willkommen bei Bookivo!',
    welcomeMessage: 'Wie können wir Ihnen heute helfen?',
    continueChat: 'Chat fortsetzen',
    startConversation: 'Gespräch starten',
    formTitle: 'Erzählen Sie uns mehr über sich',
    namePlaceholder: 'Ihr Name',
    emailPlaceholder: 'Ihre E-Mail',
    phonePlaceholder: 'Ihre Telefonnummer',
    nameRequired: 'Bitte geben Sie Ihren Namen ein',
    emailRequired: 'Bitte geben Sie Ihre E-Mail ein',
    emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    phoneRequired: 'Bitte geben Sie Ihre Telefonnummer ein',
    startChat: 'Chat starten',
    chatTitle: 'Support-Chat',
    chatTitleNoAgent: 'Verbinde...',
    endChat: 'Chat beenden',
    inputPlaceholder: 'Geben Sie Ihre Nachricht ein...',
    greeting: 'Hallo',
    greetingMessage: 'Wie kann ich Ihnen heute helfen?',
    emoji: 'Emoji',
    uploadImage: 'Bild hochladen',
    sending: 'Wird gesendet...',
    uploadFailed: 'Upload fehlgeschlagen, bitte versuchen Sie es erneut',
    fileTooLarge: 'Die Dateigröße darf 10 MB nicht überschreiten',
    invalidFileType: 'Es können nur Bilddateien hochgeladen werden',
    sendFailed: 'Nachricht konnte nicht gesendet werden, bitte versuchen Sie es erneut',
    imageSendFailed: 'Bild konnte nicht gesendet werden, bitte versuchen Sie es erneut',
    connectionLost: 'Verbindung verloren, bitte schließen und öffnen Sie den Chat erneut',
    uploading: 'Bild wird hochgeladen...',
    sessionEnded: 'Sitzung beendet',
    rating: {
      title: 'Vielen Dank für die Nutzung unseres Services. Bitte bewerten Sie Ihre Erfahrung!',
      satisfied: 'Zufrieden',
      dissatisfied: 'Unzufrieden',
      placeholder: 'Herzlich willkommen für Vorschläge',
      submit: 'Bewertung absenden',
      endChat: 'Chat beenden',
      backToChat: 'Zurück zum Chat',
      success: 'Vielen Dank für Ihr Feedback!'
    }
  }
}
